import React, { useEffect, useRef, useState } from "react";
import "../../Style/notification.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { SERVER_IP } from "../../Server";
import moment from "moment";

export default function Notifications({ setNewNotification = () => {}, newNotification = [] }) {
  const [notifications, setNotifications] = useState([]);
  const intervalRef = useRef(null);

  const user = useSelector((state) => state?.userData);
  const userDetails = user?.userDetails?.user;
  const userId = userDetails?.uuid;
  const groupId = userDetails?.group?.uuid;

  const fetchWorkFlowNotifications = async () => {
    try {
      const { data } = await axios.post(`${SERVER_IP}/user/workflow/notification`, {
        userId,
        groupId,
      });

      const formattedData = (data?.data || []).map((item) => ({
        id: item.id,
        name: item.message,
        time: item.time,
      }));

      const now = new Date();
      const threeMinutesAgo = new Date(now.getTime() - 3 * 60 * 1000);

      setNewNotification((prev) => {
        const unseen = formattedData.filter((n) => {
          if (!n.time) return false;
          const notifTime = new Date(n.time);
          const alreadyInNew = prev.some((nn) => nn.id === n.id);
          if (!alreadyInNew) {
            n.seen = true;
          }
          return !alreadyInNew && notifTime >= threeMinutesAgo;
        });
        return [...prev, ...unseen];
      });

      setNotifications(formattedData);
    } catch (error) {
      console.error("Fetch notifications error:", error);
    }
  };

  useEffect(() => {
    if (userId && groupId) {
      fetchWorkFlowNotifications();
      intervalRef.current = setInterval(fetchWorkFlowNotifications, 5000);
    }
    return () => clearInterval(intervalRef.current);
  }, [userId, groupId]);

  return (
    <div className={notifications.length > 0 ? "notification-container" : "notification-container-empty"}>
      {notifications.length > 0 ? (
        <div className="notif-list">
          {notifications.map((n) => {
            const isNew = newNotification.some((nn) => nn.seen && nn.id === n.id);
            return (
              <div key={n.id} className={`notif-item ${isNew ? "new" : ""}`}>
                <p>{n.name || "Notification"}</p>
                <span>{moment(n.time || "").format('DD-MM-YYYY')}</span>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="notifications-empty" role="status" aria-live="polite">
          <div className="empty-dot" />
          <p className="empty-title">No notifications to show</p>
          <small className="empty-subtitle">You're all caught up. We'll let you know when something new arrives.</small>
        </div>
      )}
    </div>
  );
}
